import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-[#F3F6FC]" data-id="element-354" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-355" data-mp="cn7t2z2b2k1g">
        <div className="text-center mb-16" data-id="element-356" data-mp="cm4yoh5rxzgs">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-[#0B1F4D]" data-id="element-357" data-mp="7qhe6f28luhm">
            THE COMPLETE <span className="text-[#1236C0]" data-id="element-358" data-mp="3g6116wcbego8">6-IN-1</span> ELECTRICAL TECHNOLOGY INSTRUCTOR{' '}
            <span className="bg-[#0B1F4D] text-[#FFD60A] px-2 box-decoration-clone" data-id="element-359" data-mp="3c4nygv4iqtlj">ATLAS</span> SYSTEM
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-360" data-mp="3px429y58uvni">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-[#F5C400] shadow-lg shadow-[#0B1F4D]/10' : 'border-[#D2DCEC] shadow-sm shadow-[#0B1F4D]/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-361" data-mp="3l27y5zmqghu1" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-[#1236C0] text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-362" data-mp="1qh60yur4683d">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-363" data-mp="20dit3o70gdw0">
                <span className="w-12 h-12 rounded-xl bg-[#0B1F4D] text-white font-extrabold text-2xl flex items-center justify-center shrink-0 border-b-4 border-[#F5C400]" aria-hidden="true" data-id="element-364" data-mp="24hgte282nuqn">
                  0{index + 1}
                </span>
                <div data-id="element-365" data-mp="1gprmas403fhq">
                  <div className="text-[#7A5C00] font-bold text-sm uppercase tracking-wider" data-id="element-366" data-mp="1gp9h35zd1qxo">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-[#0B1F4D]" data-id="element-367" data-mp="1ps0wfgvcx6ul">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-[#7A5C00] font-semibold mb-6 border-l-4 border-[#F5C400] pl-4" data-id="element-368" data-mp="x2bu906wv0re">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-369" data-mp="16u7qe5pfsgsz">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm leading-relaxed" data-id="element-370" data-mp="120lp19oq3zch">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-371" data-mp="9b6f6n8soci5">
                      {volume.questions.map(question => <li key={question} className="text-[#0B1F4D] font-semibold text-sm bg-[#F3F6FC] border border-[#D2DCEC] rounded-lg px-3 py-2" data-id="element-372" data-mp="2pr2qvpnd4r67">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-[#0B1F4D] font-bold text-base bg-[#E5ECF8] border-l-4 border-[#F5C400] rounded-lg px-4 py-3" data-id="element-373" data-mp="38qp189gfbpcn">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-slate-700 text-sm leading-relaxed" data-id="element-374" data-mp="2zrlgl11lz1w1">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-375" data-mp="1obd9cmb8f2e1">
                <div data-id="element-376" data-mp="1obwt88kg00up">
                  <p className="text-[#0B1F4D] font-semibold text-sm mb-3" data-id="element-377" data-mp="1o7z7df6hcv74">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-378" data-mp="23lti7qmwh4q3">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-379" data-mp="2mjctz20qt1g7">
                        <CheckCircle2 size={18} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-380" data-mp="2mgi959dthem9" />
                        <span className="text-slate-700 text-sm" data-id="element-381" data-mp="2ifetonzolklk">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-382" data-mp="122q11mthpku6">
                    <p className="text-[#0B1F4D] font-semibold text-sm mb-3" data-id="element-383" data-mp="1239g8vrr9v4i">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-384" data-mp="x69bco6n6yez">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-385" data-mp="rzuigqtpm0rx">
                          <CheckCircle2 size={18} className="text-[#1236C0] shrink-0 mt-0.5" data-id="element-386" data-mp="wxvx8zk3rdxl" />
                          <span className="text-slate-700 text-sm" data-id="element-387" data-mp="11p48m14zt9de">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-388" data-mp="1arn8qdhe97vy">
                  {volume.sequenceIntro && <p className="text-[#0B1F4D] font-semibold text-sm mb-2" data-id="element-389" data-mp="1fpeyp1yhajxi">{volume.sequenceIntro}</p>}
                  <p className="text-[#0B1F4D] font-bold text-sm bg-[#E5ECF8] border border-[#D2DCEC] rounded-lg px-3 py-2" data-id="element-390" data-mp="1klds53ynys4s">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-[#F3F6FC] border border-[#D2DCEC] border-l-4 border-l-[#0B1F4D] rounded-xl p-4 mt-auto" data-id="element-391" data-mp="3edvpmahfktxy">
                <span className="text-[#0B1F4D] font-bold block mb-1" data-id="element-392" data-mp="39gdpn9le5p23">RESULT</span>
                {volume.resultLead && <p className="text-slate-700 text-sm" data-id="element-393" data-mp="3odwdm9q8vy8h">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-[#0B1F4D]" data-id="element-394" data-mp="3jc710pndjcia">{volume.resultQuote}</span>
                  </p>}
                <p className="text-slate-700 text-sm" data-id="element-395" data-mp="3se6l5qtoqwpg">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-[#1236C0]" data-id="element-396" data-mp="ay88jxzm299j">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}